import { component } from "picoapp";
import { getFullyQualifiedUrl } from "../../utilities/general";

export const camilaSelect = component((node: HTMLElement) => {
  const button = node.querySelector<HTMLButtonElement>("[data-button]");
  const options = node.querySelectorAll<HTMLInputElement>(
    "input[type='radio']"
  );
  const thumbnailBackground = node.querySelector<HTMLDivElement>(
    "[data-thumbnail-background]"
  );
  const currentLabel = node.querySelector<HTMLParagraphElement>(
    "[data-current-label]"
  );
  const closeButton = node.querySelector<HTMLButtonElement>("[data-close]");
  const disableAccessibilityOptions =
    node.dataset.disableAccessibility === "true";

  const thumbnailImage =
    node.querySelector<HTMLImageElement>("[data-thumbnail]");

  const toggleSelect = () => {
    if (button.getAttribute("aria-expanded") === "true") {
      button.removeAttribute("aria-expanded");
    } else {
      if (node.dataset.selectType === "product") {
        const productSelects = document.querySelectorAll<HTMLElement>(
          "[data-select-type='product']"
        );
        productSelects.forEach((productSelect) => {
          if (productSelect !== node) {
            const _button =
              productSelect.querySelector<HTMLButtonElement>("[data-button]");
            _button.removeAttribute("aria-expanded");
          }
        });
      }
      button.setAttribute("aria-expanded", "true");
    }
  };

  const updateThumbnail = (optionElement: HTMLInputElement) => {
    if (!thumbnailImage) {
      return;
    }

    const newImageUrl = getFullyQualifiedUrl(optionElement.dataset.imageSrc);
    thumbnailImage.setAttribute("src", newImageUrl.href);
    thumbnailBackground.style.backgroundColor =
      optionElement.dataset.backgroundColor || "";
  };

  const handleOptionChange = ({
    currentTarget,
  }: InputEvent & { currentTarget: HTMLInputElement }) => {
    selectProduct(currentTarget);
    button.focus();
  };

  const selectProduct = (option: HTMLInputElement) => {
    currentLabel.dataset.value = option.value;
    currentLabel.innerHTML = option.dataset.label;
    updateThumbnail(option);
    if (!disableAccessibilityOptions) {
      toggleSelect();
    }
  };

  const handleOutsideClick = ({ target }: MouseEvent & { target: Element }) => {
    if (
      !node.contains(target) &&
      button.getAttribute("aria-expanded") === "true"
    ) {
      toggleSelect();
    }
  };

  const clickSameOption = ({
    target,
  }: Event & { target: HTMLInputElement }) => {
    if (target.value === currentLabel.dataset.value) {
      toggleSelect();
    }
  };

  const enableAccessibility = () => {
    document.addEventListener("click", handleOutsideClick);
    options.forEach((optionElement) => {
      optionElement.addEventListener("click", clickSameOption);
    });
  };

  options.forEach((optionElement) => {
    optionElement.addEventListener("change", handleOptionChange);
  });
  button.addEventListener("click", toggleSelect);

  if (!disableAccessibilityOptions) {
    enableAccessibility();
  }

  if (closeButton) {
    closeButton.addEventListener("click", toggleSelect);
  }

  return () => {
    button.removeEventListener("click", toggleSelect);
    options.forEach((optionElement) => {
      optionElement.removeEventListener("click", handleOptionChange);
    });

    if (!disableAccessibilityOptions) {
      document.removeEventListener("click", handleOutsideClick);
      options.forEach((optionElement) => {
        optionElement.removeEventListener("click", clickSameOption);
      });
    }
  };
});
